import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'cp-unknown',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './unknown.component.html',
  styleUrl: './unknown.component.scss',
})
export class UnknownComponent {}
